import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import "react-input-range/lib/css/index.css";
import InputRange from "react-input-range";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { BsFilterRight } from "react-icons/bs";
import Accordion from "react-bootstrap/Accordion";
import { FiChevronDown } from "react-icons/fi";
import { HiOutlineArrowNarrowDown } from "react-icons/hi";
import { BsFilterCircle } from "react-icons/bs";
import { GrFormClose } from "react-icons/gr";

import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import useWindowSize from "utils/Uti";
import "./mobileacc.css";

import useAxios from "services/useAxios.tsx";
import Loader from "components/kits/Loader/Loader.tsx";
import WebInfoContext from "context/WebInfo/WebInfoContext.ts";
import Pagination from "rc-pagination";
import { addCommas } from "@persian-tools/persian-tools";
import { isEmpty } from "lodash";
import FilterCart from "./FilterPart/FilterCart";
import { areArraysEqualByUniqueField } from "utils/Helper.ts";
import ManagementCategory from "../subCategory/ManagementCategory";
import ProductCard from "../../common/product/ProductCard";
import SortProduct from "./SortProduct";
import FilterMobile from "./FilterPart/FilterMobile";
import ProductContext from "context/ProductContext/ProductDataContext";

export default function MobileAccesories({ favorites = false }) {
  const webInfo = useContext(WebInfoContext);
  // const { productListUpdater, setProductListUpdater } =
  //   useContext(ProductContext);

  const { execute: productListApi } = useAxios("api3/filterproducts");
  const { execute: searchApi } = useAxios("api3/search");
  const { execute: getMainOption } = useAxios("api3/option_list");
  const { execute: findBrandsApi } = useAxios("brand/Find_Brand");

  const { id } = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [optionList, setOptionList] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [productListState, setProductListState] = useState([]);
  const [productListUpdater, setProductListUpdater] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [open, setOpen] = useState(false);
  const [chooseitem, setChooseItem] = useState(1);
  const [subCategory, setSubCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState({});
  const [selectedSubCategory, setSelectedSubCategory] = useState("0");

  const [minPriceValue, setMinPriceValue] = useState(0);
  const [maxPriceValue, setMaxPriceValue] = useState(0);
  const [priceValue, setPriceValue] = useState({ min: "", max: "" });
  const [availableProduct, setAvailableProduct] = useState(false);
  const [hasDiscountedProduct, setHasDiscountedProduct] = useState(false);
  const [checkedOptions, setCheckedOptions] = useState([]);

  const [sort, setSort] = useState("best_sellers");
  const [activePage, setActivePage] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const [filteredCategory, setFilteredCategory] = useState("");
  const [subSelect, setSubSelect] = useState("0");
  const [brands, setBrands] = useState([]);

  const [options, setOptions] = useState([]);

  const { width } = useWindowSize();
  const optionItem = [
    { title: "پربازدیدترین", value: "most_visited" },
    { title: "پرفروش ترین", value: "best_sellers" },
    { title: "ارزانترین", value: "cheapest" },
    { title: "گران ترین", value: "expensive" },
    { title: "جدیدترین", value: "new" },
  ];

  const getProductList = () => {
    const params = getUrlData();
    let formData = new FormData();
    if (favorites) {
      formData.append("favorites", 1);
    } else {
      let tempTag = [];
      tempTag = [subSelect == "0" ? calculateIdAll : subSelect];
      if (params[7] != "" && params[7] != null && params[7] != undefined) {
        tempTag = [...tempTag, params[7]];
      }
      formData.append("hashtag_id", tempTag?.toString());
    }
    if (params[1] !== null) {
      formData.append(`${params[1]}`, 1);
    } else if (sort !== undefined) {
      formData.append(`${sort}`, 1);
    }
    if (params[2] !== null) {
      formData.append("price", params[2]);
    }
    if (params[3] !== null) {
      formData.append("available", params[3]);
    }
    if (!isEmpty(params[5]) && params[5] !== null && params[5] !== "") {
      console.log(params[5]);
      formData.append("options", params[5]);
    }
    if (params[6] !== null) {
      formData.append("hasDiscount", params[6]);
    }
    if (brands?.filter((v) => v?.isChecked)?.length != 0) {
      let temp = brands?.filter((v) => v?.isChecked)?.map((value) => value?.id);
      formData.append("brands", temp?.toString());
    }
    formData.append("page", params[0] !== null ? params[0] : activePage);
    formData.append("count", 12);
    productListApi(formData).then((result) => {
      if (result != undefined) {
        setProductListState(result.products);
        setTotalProducts(result.total);
        setMinPriceValue(+result.min);
        setMaxPriceValue(+result.max);
      }
      setLoading(false);
    });
  };

  const getSearchData = () => {
    const params = getUrlData();

    let data = {};
    data.count = 12;
    data.page = params[0] !== null ? params[0] : activePage;
    if (params[4] !== null) {
      data.title = params[4];
    }

    if (params[2] !== null) {
      data.price = params[2];
    }
    if (params[3] !== null) {
      data.available = 1;
    }
    if (params[6] !== null) {
      data.hasDiscount = 1;
    }
    if (!isEmpty(params[5]) && params[5] !== null && params[5] !== "") {
      data.options = params[5];
    }
    searchApi(data).then((res) => {
      setProductListState(res.products);
      setTotalProducts(res.total_products);
      setLoading(false);
    });
  };
  // Handle page change
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    changeUrlParams("page", pageNumber);
  };
  const changeUrlParams = (name, value) => {
    urlParams.set(`${name}`, value);
    const paramString = urlParams.toString();
    const newUrl = paramString.replace(/%2C/g, ",");
    navigate(`?${newUrl}`);
  };

  const resetFilters = () => {
    if (
      priceValue.min !== "" ||
      priceValue.max !== "" ||
      availableProduct ||
      hasDiscountedProduct
    ) {
      setPriceValue({ min: "", max: "" });
      setAvailableProduct(false);
      setHasDiscountedProduct(false);
      setCheckedOptions([]);
      const urlParams = new URLSearchParams(location.search);
      urlParams.delete("available");
      urlParams.delete("hasDiscount");
      urlParams.delete("price");
      urlParams.delete("options");
      const newUrl = `?${urlParams.toString()}`;
      navigate(newUrl);
      setProductListUpdater((prev) => !prev);
    }
  };

  const getUrlData = () => {
    let page = null;
    let sort = null;
    let price = null;
    let available = null;
    let hasDiscount = null;
    let keyword = null;
    let _options = null;
    let sub = "";

    if (location.pathname.includes("search")) {
      const urlParams = new URLSearchParams(location.search);

      keyword = urlParams.get("keyword");
      page = urlParams.get("page");
      if (page !== null) setActivePage(+page);
      sort = urlParams.get("sort");
      if (sort !== null) setSort(sort);
      price = urlParams.get("price");
      if (price !== null) {
        const numbers = price.split(",");
        setPriceValue({ min: numbers[0], max: numbers[1] });
      }
      available = urlParams.get("available");
      if (available !== null) setAvailableProduct(true);
      hasDiscount = urlParams.get("hasDiscount");
      if (hasDiscount !== null) setHasDiscountedProduct(true);
      _options = urlParams.get("options");

      if (_options !== null) {
        const op = _options.split(",");
        setCheckedOptions(op);
        op.forEach((val) => {
          setOptions((prev) => {
            const updatedOption = prev.map((value) => {
              return {
                ...value,
                features: value.features.map((feature) => {
                  if (feature.id === val) {
                    return { ...feature, isChecked: true };
                  }
                  return feature;
                }),
              };
            });
            return updatedOption;
          });
        });
      }
    } else {
      const params = location.search.split("&");
      params.forEach((param) => {
        if (param.includes("page=")) {
          page = param.split("=")[1];
          setActivePage(+page);
        } else if (param.includes("sort=")) {
          sort = param.split("=")[1];
          setSort(sort);
        } else if (param.includes("price=")) {
          price = param.split("=")[1];
          const numbers = price.split(",");
          setPriceValue({ min: numbers[0], max: numbers[1] });
        } else if (param.includes("available=")) {
          available = param.split("=")[1];
          setAvailableProduct(true);
        } else if (param.includes("hasDiscount=")) {
          hasDiscount = param.split("=")[1];
          setHasDiscountedProduct(true);
        } else if (param.includes("options")) {
          _options = param.split("=")[1];
          const op = _options.split(",");
          setCheckedOptions(op);
          op.forEach((val) => {
            setOptions((prev) => {
              const updatedOption = prev.map((value) => {
                return {
                  ...value,
                  features: value.features.map((feature) => {
                    if (feature.id === val) {
                      return { ...feature, isChecked: true };
                    }
                    return feature;
                  }),
                };
              });
              return updatedOption;
            });
          });
        } else if (param.includes("sub=")) {
          sub = param.split("=")[1] ?? "";
        }
      });
    }
    return [page, sort, price, available, keyword, _options, hasDiscount, sub];
  };

  const submitFilters = () => {
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(
      "price",
      `${priceValue.min !== "" ? priceValue.min : 0},${
        priceValue.max !== "" ? priceValue.max : 0
      }`
    );
    urlParams.set("page", 1);
    if (checkedOptions.length !== 0 && checkedOptions[0] !== "") {
      urlParams.set("options", checkedOptions.join(","));
    } else {
      urlParams.delete("options");
    }
    if (availableProduct) {
      // Set "available" to false and update URL
      urlParams.set("available", "1");
    } else {
      // Remove "available" from URL
      urlParams.delete("available");
    }
    if (hasDiscountedProduct) {
      // Set "hasDiscount" to false and update URL
      urlParams.set("hasDiscount", "1");
    } else {
      // Remove "hasDiscount" from URL
      urlParams.delete("hasDiscount");
    }
    const paramString = urlParams.toString();
    const newUrl = paramString.replace(/%2C/g, ",");
    navigate(`?${newUrl}`);
    // getSearchData()
    handleClose();
    setProductListUpdater((prev) => !prev);
  };

  const getCategoryList = () => {
    if (filteredCategory.length == 0) return;
    let temp = filteredCategory.find((item) => {
      if (item.hashtag.id === id) {
        return true;
      }
      if (item.subs) {
        const matchedSub = item.subs.find((sub) => sub.id === id);
        if (matchedSub) {
          return true;
        }
      }
      return false;
    });
    // console.log({ temp });
    // let temp = filteredCategory.filter((it) => +it.hashtag.id === +id)[0];
    if (temp !== undefined) {
      setSubCategory(
        temp.subs.map((it) => ({ ...it, parent: temp.hashtag.id }))
      );
      setSelectCategory(temp);
    }
  };

  const changeCategoryURL = (_id, type = "", setPageToOne = true) => {
    const urlParams = new URLSearchParams(location.search);

    if (id == _id) {
      if (type == "all-cat") {
        urlParams.delete("sub");
      }
      setSubSelect(
        subCategory.length == 0 || !subCategory.some((it) => it.id == id)
          ? "0"
          : _id
      );
      setSelectedSubCategory(_id);
    } else {
      urlParams.set("sub", _id);
    }
    if (setPageToOne) {
      urlParams.set("page", 1);
    }

    const paramString = urlParams.toString();
    const newUrl = paramString.replace(/%2C/g, ",");
    navigate(`?${newUrl}`);
    setProductListUpdater((prev) => !prev);

    // const currentPathname = location.pathname;
    // const regex = /\/category\/(\d+)/;
    // const match = currentPathname.match(regex);
    // const currentValue = match && match[1];
    // const newValue = _id; // New value you want to set

    // if (currentValue) {
    //   const newUrl = currentPathname.replace(currentValue, newValue);
    //   navigate(`${newUrl}${location.search}`);
    // }
  };

  const handleClickCheckInput = (id, type = "option") => {
    if (type == "option") {
      const updatedOptions = options.map((item) => {
        return {
          ...item,
          features: item.features.map((feature) => {
            if (feature.id === id) {
              return {
                ...feature,
                isChecked: !feature.isChecked, // Toggle the checked property
              };
            }
            return feature;
          }),
        };
      });

      setOptions(updatedOptions);

      const checkedIds = updatedOptions
        .filter((item) => item.features.some((feature) => feature.isChecked))
        .flatMap((item) => item.features.filter((feature) => feature.isChecked))
        .map((feature) => feature.id);

      setCheckedOptions(checkedIds);
    } else if (type == "brand") {
      let temp = brands?.findIndex((v) => v?.id == id);
      let value = brands?.find((v) => v?.id == id)?.isChecked ?? null;

      let finalValue = [...brands];
      finalValue[temp] = {
        ...finalValue[temp],
        isChecked: value == null ? false : !value,
      };
      setBrands(finalValue);
    }
  };

  useEffect(() => {
    async function loadPage() {
      await getMainOption().then((res) => {
        setOptionList(res.result);
        if (res.result?.length == 0 || webInfo.categorys.length == 0) return;
      });
      const filteredObjects = webInfo.categorys.filter((obj) => {
        if (
          location.pathname.includes("category") &&
          [0, 1].includes(+obj.hashtag.type)
        ) {
          return true;
        } else if (
          location.pathname.includes("blog") &&
          [0, 2].includes(+obj.hashtag.type)
        ) {
          return true;
        }
        return false;
      });
      console.log("subCheckCat: ", filteredObjects);
      setFilteredCategory(filteredObjects);
    }
    loadPage();

    // }, [webInfo.categorys, webInfo.options]);
  }, [webInfo.categorys]);

  useEffect(() => {
    if (!favorites && (id.includes("search") || webInfo.categorys.length == 0))
      return;
    let tempOptions = [];

    // get options array without repete
    const getOptionsCategory = (categoryId) => {
      let tempCat = webInfo.categorys.find((it) => it.hashtag.id == categoryId);
      if (!tempCat) {
        tempCat = webInfo.categorys.find((it) =>
          it.subs.some((item) => item.id == categoryId)
        );
      }
      let tempOpt = [];

      tempCat?.hashtag.options.map(
        (opt) =>
          !tempOpt.some((it) => it.option_id == opt.option_id) &&
          tempOpt.push(opt)
      );
      tempCat?.subs.map((sub) => {
        sub.options.map(
          (opt) =>
            !tempOpt.some((it) => it.option_id == opt.option_id) &&
            tempOpt.push(opt)
        );
      });
      return tempOpt;
    };

    if (subSelect == "0") {
      if (subCategory.length == 0) {
        tempOptions = getOptionsCategory(id);
        console.log("A");
      } else {
        if (subCategory.find((it) => it.id == selectedSubCategory)) {
          tempOptions = getOptionsCategory(
            subCategory.find((it) => it.id == selectedSubCategory).parent
          );
          console.log("B");
        } else {
          tempOptions = getOptionsCategory(id);
          // console.log("C: ",tempOptions)
        }
      }
      // console.log("AllOptions:",subCategory.find(it => it.id == selectedSubCategory))
    } else {
      tempOptions =
        subCategory?.find((it) => it.id == selectedSubCategory)?.options ?? [];
    }

    const _options = tempOptions?.map((value) => {
      return {
        ...value,
        features: value.features.map((feature) => {
          return { ...feature, isChecked: false };
        }),
      };
    });

    // console.log("options1: ", tempOptions);
    if (
      !areArraysEqualByUniqueField(options, _options, "id") ||
      getUrlData()[5] == null
    ) {
      // console.log("setOptions");
      setOptions(_options);
      getUrlData();
    }
  }, [subCategory, selectedSubCategory, subSelect]);

  useEffect(() => {
    if (subCategory === selectedSubCategory || filteredCategory === "") return;
    console.log("test");
    setLoading(true);
    if (!favorites && id.includes("search")) {
      getSearchData();
    } else {
      getProductList(sort);
    }
    getCategoryList();
  }, [
    productListUpdater,
    chooseitem,
    selectedSubCategory,
    activePage,
    subSelect,
    filteredCategory,
  ]);

  useEffect(() => {
    changeCategoryURL(id, "", false);
  }, [id]);

  useEffect(() => {
    async function loadPage() {
      await findBrandsApi().then((res) => {
        setBrands(res?.map((v) => ({ ...v, isChecked: false })));
      });
    }
    loadPage();
  }, []);

  const calculateIdAll = useMemo(() => {
    if (subSelect == "0") {
      if (subCategory.length == 0) {
        return id;
      } else {
        if (subCategory.find((it) => it.id == selectedSubCategory)) {
          return subCategory.find((it) => it.id == selectedSubCategory).parent;
        } else {
          return selectedSubCategory;
        }
      }
    } else {
      return selectedSubCategory;
    }
  }, [subCategory, selectedSubCategory, subSelect]);
  return (
    <section className="mobile_accessories">
      <Helmet>
        {favorites ? (
          <title>علاقه‌مندی‌ها</title>
        ) : (
          <title>پت شاپ / {selectCategory?.hashtag?.txt ?? "فروشگاه"}</title>
        )}
      </Helmet>
      <Container fluid>
        <div className="mobile-accessories-box px-2">
          {!favorites && !id.includes("search") && (
            <div className="mobile-access-head">
              <Link
                className="text-decoration-none mobile-access-head"
                to={"/"}
              >
                <span className="ps-2">فروشگاه</span>
              </Link>
              <span className="ps-2">/</span>
              <Link
                className="text-decoration-none mobile-access-head"
                to={"/"}
              >
                <span className="ps-2">دسته بندی ها</span>
              </Link>
              <span className="ps-2">/</span>
              <Link
                className="text-decoration-none mobile-access-head"
                to={"/"}
              >
                <span>{selectCategory?.hashtag?.txt}</span>
              </Link>
            </div>
          )}

          <div className="mobile-access-categorys mr-t-12">
            {favorites ? (
              <p className="mobile-access-categorys-title">علاقه‌مندی‌ها</p>
            ) : (
              !id.includes("search") && (
                <>
                  <p className="mobile-access-categorys-title">زیردسته ها</p>
                  {loading ? (
                    <div className="w-100 d-flex justify-content-center pd-t-24">
                      <Loader width={40} />
                    </div>
                  ) : id != 66 ? (
                    <ManagementCategory
                      subCategory={subCategory}
                      subSelect={subSelect}
                      setSubSelect={setSubSelect}
                      selectCategory={selectCategory}
                      changeCategoryURL={changeCategoryURL}
                    />
                  ) : (
                    <ManagementCategory
                      subCategory={subCategory?.filter(
                        (value) => value?.id == 66
                      )}
                      subSelect={subSelect}
                      setSubSelect={setSubSelect}
                      selectCategory={selectCategory}
                      changeCategoryURL={changeCategoryURL}
                    />
                  )}
                </>
              )
            )}

            <div className="mobile-accessories-products">
              <Row>
                <FilterCart
                  resetFilters={resetFilters}
                  options={options}
                  handleClickCheckInput={handleClickCheckInput}
                  availableProduct={availableProduct}
                  setAvailableProduct={setAvailableProduct}
                  hasDiscountedProduct={hasDiscountedProduct}
                  setHasDiscountedProduct={setHasDiscountedProduct}
                  submitFilters={submitFilters}
                  priceValue={priceValue}
                  setPriceValue={setPriceValue}
                  minPriceValue={minPriceValue}
                  maxPriceValue={maxPriceValue}
                  brands={brands}
                />
                <div className="col-12 col-xl-10 d-flex flex-column">
                  <div className="col-12">
                    <div className="mobile-accessories-ordering">
                      <div className="accessories-ordering-items">
                        <div
                          className="accessories-ordering-fil-mob"
                          onClick={handleShow}
                        >
                          <BsFilterCircle size={25} />
                          <span>فیلتر</span>
                        </div>

                        <FilterMobile
                          show={show}
                          handleClose={handleClose}
                          resetFilters={resetFilters}
                          options={options}
                          handleClickCheckInput={handleClickCheckInput}
                          maxPriceValue={maxPriceValue}
                          minPriceValue={minPriceValue}
                          priceValue={priceValue}
                          setPriceValue={setPriceValue}
                          availableProduct={availableProduct}
                          setAvailableProduct={setAvailableProduct}
                          hasDiscountedProduct={hasDiscountedProduct}
                          setHasDiscountedProduct={setHasDiscountedProduct}
                          submitFilters={submitFilters}
                          brands={brands}
                        />
                        <div className="d-flex align-items-center">
                          {" "}
                          <div
                            className="Ordering-box-icons d-flex"
                            onClick={() => setOpen(true)}
                          >
                            <BsFilterRight size={25} fontWeight="bold" />
                            <HiOutlineArrowNarrowDown
                              size={20}
                              className="ordering-items-arrow"
                            />
                          </div>
                          <span
                            className="ordering-items-options "
                            style={{ minWidth: 70 }}
                          >
                            {/* {width < 1024 && chooseitem
                            ? optionItem[chooseitem].title
                            : "مرتب سازی"} */}
                            مرتب سازی
                          </span>
                          <SortProduct
                            open={open}
                            setOpen={setOpen}
                            optionItem={optionItem}
                            setChooseItem={setChooseItem}
                            setSort={setSort}
                            changeUrlParams={changeUrlParams}
                            setActivePage={setActivePage}
                            chooseitem={chooseitem}
                            isMobile={false}
                          />
                        </div>
                      </div>
                      <div className="accessories-ordering-commodity">
                        <span className="font-12-500">
                          {totalProducts} کالا
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* {width < 1024 && (
                    <SortProduct
                      isMobile={true}
                      open={open}
                      setOpen={setOpen}
                      optionItem={optionItem}
                      setChooseItem={setChooseItem}
                      setSort={setSort}
                      changeUrlParams={changeUrlParams}
                      setActivePage={setActivePage}
                      chooseitem={chooseitem}
                    />
                  )} */}

                  {loading ? (
                    <div className="w-100 d-flex justify-content-center pd-t-24">
                      <Loader width={40} />
                    </div>
                  ) : (
                    <>
                      <div className="d-flex flex-wrap">
                        {/* shFazeli 1402/04/14 it changed to a component and connect to api */}
                        {productListState?.length > 0 ? (
                          productListState.map((value) => (
                            <>
                              <ProductCard
                                isCategory={true}
                                data={value}
                                setUpdater={setProductListUpdater}
                              />
                            </>
                          ))
                        ) : (
                          <div className="text-center w-100 font-14-400 text-secondary text-opacity-75 mr-t-20">
                            « در حال حاضر محصولی برای این دسته بندی موجود نیست »
                          </div>
                        )}
                      </div>

                      {productListState?.length > 0 && (
                        <Pagination
                          className="px-1 mt-3 align-self-center"
                          total={totalProducts}
                          pageSize={12}
                          current={activePage}
                          onChange={(newPage) => {
                            handlePageChange(newPage);
                          }}
                        />
                      )}
                    </>
                  )}
                </div>
              </Row>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
